import { render, staticRenderFns } from "./LowVision.vue?vue&type=template&id=e655e994"
import script from "./LowVision.vue?vue&type=script&lang=js"
export * from "./LowVision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports